import { render, staticRenderFns } from "./QuiltDialog.vue?vue&type=template&id=0385bd75&scoped=true&"
import script from "./QuiltDialog.vue?vue&type=script&lang=js&"
export * from "./QuiltDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuiltDialog.vue?vue&type=style&index=0&id=0385bd75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385bd75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VImg})
